// extracted by mini-css-extract-plugin
module.exports = {"container":"Toggle_container__N--tr","disabled":"Toggle_disabled__15vyV","toggle":"Toggle_toggle__xV_Sg","selected":"Toggle_selected__2BF_S"};